import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M20 21H4C2.89543 21 2 20.1046 2 19V5C2 3.89543 2.89543 3 4 3H10C10.2652 3 10.5195 3.10545 10.707 3.293L12.414 5H20C21.1046 5 22 5.89543 22 7V19C22 20.1046 21.1046 21 20 21ZM4 7V19H20V7H4Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Folder"
);
